import React from 'react';
import {useIntl} from 'react-intl';
import classnames from 'classnames';
import moment from 'moment';
import PopupAddInvitedBy from './PopupAddInvitedBy';
import {copyToClipboard} from '../../../../utils';
import PropTypes from 'prop-types';
import styles from '../styles.module.scss';

const CopyToClipboard = ({value}) => {

  return (
    <div className={styles.copyButton}>
      <svg width="16px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" fill="none">
          <rect x="0" y="0" width="24" height="24"/>
          <path
            d="M15.9956071,6 L9,6 C7.34314575,6 6,7.34314575 6,9 L6,15.9956071 C4.70185442,15.9316381
                  4,15.1706419 4,13.8181818 L4,6.18181818 C4,4.76751186 4.76751186,4 6.18181818,4 L13.8181818,4
                  C15.1706419,4 15.9316381,4.70185442 15.9956071,6 Z"
            fill="#3699ff" opacity="0.4"/>
          <path
            d="M10.1818182,8 L17.8181818,8 C19.2324881,8 20,8.76751186 20,10.1818182 L20,17.8181818
                  C20,19.2324881 19.2324881,20 17.8181818,20 L10.1818182,20 C8.76751186,20 8,19.2324881
                  8,17.8181818 L8,10.1818182 C8,8.76751186 8.76751186,8 10.1818182,8 Z"
            fill="#3699ff"
            className={styles.copyIcon}
            onClick={() => copyToClipboard(value)}
          />
        </g>
      </svg>
    </div>
  );
};

export const InvitedBy = ({data}) => {
  const {invitedByUser} = data;
  const username = invitedByUser?.username ? invitedByUser.username : '';
  const fullName = invitedByUser?.fullName ? invitedByUser.fullName : '';
  const email = invitedByUser?.email ? invitedByUser.email : '';
  const inviteDate = invitedByUser?.inviteDate ? moment(invitedByUser.inviteDate).format('DD/MM/YYYY') : '';
  const intl = useIntl();
  const prefix = 'userDetails-invited-by';

  return (
    <div className={styles.invitedByContainer}>
      <div className={styles.header}>
        {intl.formatMessage({id: `${prefix}`, defaultMessage: 'Invited by'})}
      </div>
      <div className={styles.item}>
        <div className={styles.label}>
          <span className={styles.labelText}>{intl.formatMessage({id: `${prefix}-username`, defaultMessage: 'Username'})}</span>
          <CopyToClipboard value={username}/>
        </div>
        {username && (
          <span className={classnames('label label-lg label-light-primary label-inline ml-auto', styles.value)}>
            {username}
          </span>
        )}
      </div>
      <div className={styles.item}>
        <div className={styles.label}>
          <span className={styles.labelText}>{intl.formatMessage({id: `${prefix}-name`, defaultMessage: 'Name'})}</span>
          <CopyToClipboard value={fullName}/>
        </div>
        {fullName && (
          <span className={classnames('label label-lg label-light-primary label-inline ml-auto', styles.value)}>
            {fullName}
          </span>
        )}
      </div>
      <div className={styles.item}>
        <div className={styles.label}>
          <span className={styles.labelText}>{intl.formatMessage({id: `${prefix}-email`, defaultMessage: 'email'})}</span>
          <CopyToClipboard value={email}/>
        </div>
        {email && (
          <span className={classnames('label label-lg label-light-primary label-inline ml-auto', styles.value)}>
            {email}
          </span>
        )}
      </div>
      <div className={styles.item}>
        <div className={styles.label}>
          <span className={styles.labelText}>{intl.formatMessage({id: `${prefix}-date`, defaultMessage: 'date'})}</span>
          <CopyToClipboard value={inviteDate}/>
        </div>
        {inviteDate && (
          <span className={classnames('label label-lg label-light-primary label-inline ml-auto', styles.value)}>
            {inviteDate}
          </span>
        )}
      </div>
      {!invitedByUser && <PopupAddInvitedBy/>}
    </div>
  );
};

InvitedBy.propTypes = {
  data: PropTypes.object
};

export default InvitedBy;
